import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from 'rsuite';
import {
  clearUploadedVideo,
  createMediaSubmission,
  getCampaignElementById,
  getHasUploadedVideoForQuestionId,
  getHasVideoBucketUploadFailed,
  getPreSignedUrlForUpload,
  getIpAddress,
  selectVideo,
  setMediaType,
  uploadVideoToBucket,
  getIsVideoUploadingToBucket,
  getCampaignId,
  getCampaignBanner,
  getUseCampaignBanner
} from '../../redux/modules/campaignLandingPage';
import styles from './VideoUploadButton.module.less';
import { ACCEPT_TYPES } from '../../constants';
import { StyledOutlineBrandingButton } from './styles';

function handleFileSelect(
  files,
  qid,
  _createMediaSubmission,
  _selectVideo,
  _setMediaType,
  _clearUploadedVideo,
  mediaSubmission
) {
  _clearUploadedVideo(qid);
  const [file] = files;
  mediaSubmission.mimeType = file.type;

  // Save file type so we can use it in the video preview
  _setMediaType(qid, file.type);

  // Create an object URL and persist it to store
  const objectUrl = window.URL.createObjectURL(file);
  _selectVideo(qid, objectUrl);
  // Fetch a pre-signed URL and store it
  _createMediaSubmission(mediaSubmission, qid);
}

const VideoUploadButton = ({
  _clearUploadedVideo,
  _createMediaSubmission,
  _selectVideo,
  _setMediaType,
  _uploadVideoToBucket,
  hasUploadedVideo,
  qid,
  signedUrl,
  userIpAddress,
  isVideoUploading,
  isDirectRecording = false,
  campaignId,
  backgroundColor,
  useBanner
}) => {
  const fileInput = useRef(null);
  const buttonLabel = isDirectRecording ? 'Record a Video' : 'Upload a Video';
  const mediaSubmission = {
    isRecorded: false,
    userAgent: navigator.userAgent,
    userIp: userIpAddress,
    screenResolution: `${window.outerWidth}x${window.outerHeight}`,
    campaignId
  };

  useEffect(() => {
    if (signedUrl !== null && hasUploadedVideo === false && fileInput.current.files.length) {
      const file = fileInput.current.files[0];
      _uploadVideoToBucket(file, signedUrl, qid);
    }
  }, [signedUrl]);

  const fileInputProps = {
    type: 'file',
    capture: isDirectRecording ? 'user' : null,
    disabled: isVideoUploading,
    id: `vpUploadInput-${qid}-${isDirectRecording}`,
    accept: ACCEPT_TYPES.VIDEO,
    ref: fileInput,
    className: styles.vpVisuallyHidden,
    onChange: (e) =>
      handleFileSelect(
        e.target.files,
        qid,
        _createMediaSubmission,
        _selectVideo,
        _setMediaType,
        _clearUploadedVideo,
        mediaSubmission
      )
  };

  const useCustomStyle = useBanner && backgroundColor;

  return (
    <>
      <StyledOutlineBrandingButton
        component="label"
        htmlFor={`vpUploadInput-${qid}-${isDirectRecording}`}
        variant="outlined"
        disabled={isVideoUploading}
        backgroundColor={backgroundColor}
        custom={useCustomStyle}
        sx={{ gap: '5px' }}
      >
        <Icon icon={isDirectRecording ? 'circle' : 'upload'} />
        {buttonLabel}
      </StyledOutlineBrandingButton>
      <input {...fileInputProps} />
    </>
  );
};

VideoUploadButton.propTypes = {
  _clearUploadedVideo: PropTypes.func,
  _createMediaSubmission: PropTypes.func,
  _selectVideo: PropTypes.func,
  _setMediaType: PropTypes.func,
  _uploadVideoToBucket: PropTypes.func,
  campaignElement: PropTypes.object,
  hasUploadedVideo: PropTypes.bool,
  hasUploadFailure: PropTypes.bool,
  qid: PropTypes.string,
  signedUrl: PropTypes.string,
  userIpAddress: PropTypes.string,
  isVideoUploading: PropTypes.bool,
  isDirectRecording: PropTypes.bool,
  campaignId: PropTypes.number,
  backgroundColor: PropTypes.string,
  useBanner: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => ({
  campaignElement: getCampaignElementById(state, ownProps.qid),
  hasUploadedVideo: getHasUploadedVideoForQuestionId(state, ownProps.qid),
  hasUploadFailure: getHasVideoBucketUploadFailed(state, ownProps.qid),
  signedUrl: getPreSignedUrlForUpload(state, ownProps.qid),
  userIpAddress: getIpAddress(state),
  isVideoUploading: getIsVideoUploadingToBucket(state, ownProps.qid),
  campaignId: getCampaignId(state),
  backgroundColor: getCampaignBanner(state),
  useBanner: getUseCampaignBanner(state)
});

const mapDispatchToProps = {
  _clearUploadedVideo: clearUploadedVideo,
  _createMediaSubmission: createMediaSubmission,
  _selectVideo: selectVideo,
  _setMediaType: setMediaType,
  _uploadVideoToBucket: uploadVideoToBucket
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoUploadButton);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/VideoUploadButton.jsx